import { render, staticRenderFns } from "./TextCol.vue?vue&type=template&id=c168b7b6"
import script from "./TextCol.vue?vue&type=script&lang=js"
export * from "./TextCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports